import React from "react";
import "./button-navigate.scss";
import classNames from "classnames";

type ButtonNavigateProps = {
    number?: number;
    text?: string;
    active?: boolean;
    completed?: boolean;
} & React.ComponentProps<"button">;

const ButtonNavigate = (props: ButtonNavigateProps) => {
    const { number, text, active = false, completed, ...rest } = props;
    const classComp = "cfmui-button-navigate";
    const myClass = classNames({
        [classComp]: true,
        [classComp + "--active"]: active,
        [classComp + "--completed"]: completed,
    });

    return (
        <button {...rest} className={myClass}>
            <span className={classComp + "__number"}>
                {completed ? "✓" : number}
            </span>
            <span className={classComp + "__text"}>{text}</span>
        </button>
    );
};

export default ButtonNavigate;
